class ChatBubbleAnimation {
    constructor(options = {}){
        this.threshold = options.threshold || 0.2;
        this.selector = options.selector || ".chat-bubble";
        this.init();
    }
    init() {
        // 創建 Intersection Observer
        this.observer = new IntersectionObserver((entries)=>{
            entries.forEach((entry)=>{
                // 當元素進入視窗時
                if (entry.isIntersecting) {
                    entry.target.classList.add("show");
                    // 元素顯示後就不需要再觀察了
                    this.observer.unobserve(entry.target);
                }
            });
        }, {
            threshold: this.threshold
        });
        // 觀察所有對話框
        document.querySelectorAll(this.selector).forEach((bubble)=>{
            this.observer.observe(bubble);
        });
    }
}
// 自動初始化
document.addEventListener("DOMContentLoaded", ()=>{
    new ChatBubbleAnimation();
});

//# sourceMappingURL=enroll.89a23edf.js.map
